<template>
    <div class="lang">
        <div class="greeting">
            <div class="greeting__inner">
                <div class="greeting__bg"><img src="/resource/img/about-bg02.png" alt=""></div>
                <div class="greeting__tit pc-none">
                    <div class="greeting__tit-inner item1">
                        <div>
                            Здравствуйте! Мы рады приветствовать Вас на сайте оздоровительно-диагностического центра.
                        </div>
                    </div>
                </div>
                <div class="greeting__img">
                    <div class="greeting__img-inner">
                        <img src="/resource/img/img_hos01_01.jpg" alt="">
                    </div>
                    <div class="greeting__img-bg"></div>
                </div>
                <div class="greeting__text">
                    <div class="greeting__tit mo-none">
                        <div class="greeting__tit-inner item1">
                            <div>
                                Здравствуйте! Мы рады приветствовать Вас на сайте оздоровительно-диагностического центра.
                            </div>
                        </div>
                    </div>
                    <div class="desc">
                        <p>
                            С момента открытия больницы Моктонг Женского университета Ихва на ее территории функционировали Женский диагностический центр Ихва и Диагностический центр , в которых существовала дружелюбная атмосфера со всеми удобствами, с удобной системой диагностики здоровья и универсальным сервисом для немедленного получения медицинской помощи в случае необходимости. Кроме того, по случаю празднования открытия больницы, диагностический центр в 2019 году объявил, что как компаньон, который заботится о счастливой и здоровой жизни пациентов, наметил своей целью стремление к здоровью (wellness), в которое входят такие понятия как благосостояние (well-being) и здоровое тело (fitness).
                        </p>
    
                        <p>
                            С 1 апреля 2020 года в Сеульской больнице Женского университета Ихва начинает свою деятельность Диагностический центр Wellness, благодаря которому больница предоставляет лучшие услуги скрининга здоровья, точную диагностику на усовершенствованном медицинском оборудовании, а также быстрое лечение с комфортными условиями.
                        </p>
    
                        <p>
                            В нашей больнице присутствует уникальная атмосфера для лечения женщин, во время которого требуется более внимательное отношение к пациенткам. Также, в нашем Медицинском центре предоставляется лечение не только женщинам, но и мужчинам, и всем людям из зарубежных стран, которые нуждаются в передовых методах лечения Кореи.
                        </p>
    
                        <p>
                            Оздоровительно-диагностический центр Wellness всегда будет с Вами и прикладывать все усилия для сохранения Вашего здоровья на долгие годы.
                        </p>
    
    
                        <div class="name">
                            <p>Руководитель</p>
                            <span>оздоровительно-диагностического центра Wellness Сонг Хе Кёнг</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { gsap, Power1 } from "gsap";
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger); // 추가된 부분
    export default {
        methods: {
            gsapAbout() {
                gsap.from(".greeting__img img", {
                    height: 0,
                    duration: 1,
                    delay: .5,
                });
                gsap.from(".greeting__img img", {
                    scale: 1.2,
                    duration: 4,
                    delay: 1.4,
                });
                gsap.from(".greeting__img-bg", {
                    opacity: 0,
                    x: 0,
                    y: 0,
                    duration: 1,
                    delay: 1.5,
                });
                gsap.from(".greeting__tit .item2 em span", {
                    width: 0,
                    duration: 1.5,
                    delay: 2,
                    ease: Power1.easeInOut,
                    // onComplete: () => {
                    //     gsap.to(".greeting__tit .item2 em span", {
                    //         backgroundColor: 'var(--aorta-P10)',
                    //         duration: 1.5
                    //     });
                    // }
                });
                gsap.from(".item1 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".item2 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".desc", {
                    opacity: 0,
                    y: 30,
                    duration: 1,
                    delay: 2.8,
                });
                gsap.from(".greeting__bg", {
                    opacity: 0,
                    duration: 3,
                    delay: 1,
                });

            }
        },
        mounted() {
            if (window.innerWidth >= 1025) {
                this.gsapAbout();
            }
        },
    }

</script>
<style>

</style>